import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useApp, API } from "../context/AppContext";
import PlanCard from "../components/PlanCard";
import { Trash2, Loader2 } from "lucide-react";

export default function Favorites() {
  const { t, user, checking, axiosOpts } = useApp();
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/favorites`, axiosOpts());
      setFavs(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [user]);

  const remove = async (id) => {
    try {
      await axios.delete(`${API}/favorites/${id}`, axiosOpts());
      setFavs((prev) => prev.filter((f) => f.id !== id));
      toast.success(t.delete);
    } catch {
      toast.error("Error");
    }
  };

  const patch = async (id, body) => {
    try {
      const { data } = await axios.patch(`${API}/favorites/${id}`, body, axiosOpts());
      setFavs((prev) => prev.map((f) => (f.id === id ? data : f)));
    } catch {
      toast.error("Error");
    }
  };

  if (checking) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="max-w-6xl mx-auto px-5 py-10">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900">{t.favorites}</h1>
      {loading ? (
        <div className="mt-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#D95338]" /></div>
      ) : favs.length === 0 ? (
        <p className="mt-8 text-stone-600" data-testid="empty-favorites">{t.emptyFav}</p>
      ) : (
        <div className="mt-8 grid gap-6">
          {favs.map((f, i) => (
            <div key={f.id} className="relative">
              <PlanCard
                plan={f.plan}
                index={i}
                canSave={false}
                showFavActions
                rating={f.rating}
                done={f.done}
                onRating={(v) => patch(f.id, { rating: f.rating === v ? null : v })}
                onToggleDone={(v) => patch(f.id, { done: v })}
              />
              <button data-testid={`button-delete-${i}`} onClick={() => remove(f.id)}
                className="absolute top-5 right-5 p-2 rounded-full bg-white border border-[#E7E0D5] hover:bg-[#FFF4EC] hover:text-[#B54708] transition-all"
                title={t.delete}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
